import * as AppPics from 'assets/images';
import AppImages from 'components/Images';
import { memo } from 'react';

function Flag({ id, name }) {
  if (['in', 'india'].includes(id))
    return <AppImages className="country_tag" src={AppPics.IndiaFlagSvg} alt={`${name} flag`} />;
  if (id === 'uk')
    return <AppImages className="country_tag" src={AppPics.UkFlagSvg} alt={`${name} flag`} />;

  return null;
}

export default memo(Flag);
